import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

export const useTopBar = () => {
  const { t } = useTranslation();
  const [isProfileDropdownOpen, setIsProfileDropdownOpen] = useState(false);
  const [isNotificationDropdownOpen, setIsNotificationDropdownOpen] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);

  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);

  return {
    t,
    isProfileDropdownOpen,
    setIsProfileDropdownOpen,
    isNotificationDropdownOpen,
    setIsNotificationDropdownOpen,
    unreadCount,
    setUnreadCount,
    pathnames
  };
};
